import 'i18next';
import { IsNotEmpty, MaxLength, MinLength } from 'class-validator';

import { t } from '@app-velocity/i18n';

export class CreateScenarioDto {
  @IsNotEmpty({
    message: t('prototypes:validation.intro_message_cannot_be_empty'),
  })
  @MinLength(1, {
    message: t('prototypes:validation.intro_message_too_short', {
      minLength: 1,
    }),
  })
  @MaxLength(2500, {
    message: t('prototypes:validation.intro_message_too_long', {
      maxLength: 2500,
    }),
  })
  introMessage = '';

  @IsNotEmpty({
    message: t('prototypes:validation.amount_cannot_be_empty'),
  })
  amount = '1';

  dontSkipVariants = false;
}
